@if (adBlock()) {
    @switch (adBlock().ad_type) {
        @case (AdTypes.SQUARE_AD) {
            <div class="flex justify-center">
                <packbo-ad-carousel [ads]="ads()" [carouselType]="AdCarouselType.SQUARE_AD" />
            </div>
        }

        @case (AdTypes.VERTICAL_AD) {
            <div class="flex justify-center pt-8 pb-6 xl:pt-12">
                <packbo-ad-carousel [ads]="ads()" [carouselType]="AdCarouselType.VERTICAL_AD" />
            </div>
        }

        @case (AdTypes.HORIZONTAL_AD) {
            <div class="bg-primary/5 py-8">
                <packbo-ad-carousel [ads]="ads()" [carouselType]="AdCarouselType.HORIZONTAL_AD" />
            </div>
        }

        @case (AdTypes.TARGETED_HORIZONTAL_AD) {
            <div class="bg-primary/5 py-8">
                <packbo-ad-carousel [ads]="ads()" [carouselType]="AdCarouselType.TARGETED_HORIZONTAL_AD" />
            </div>
        }
    }
}
